import Parvus from 'parvus'

const prvs = new Parvus({
  zoomIndicator: false,

})
